import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate,setDateRange } from './Function';
import { Row,Col,Card,Placeholder, Button } from 'react-bootstrap';
const ResearchProjects = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[Projects,setProjects]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        ResearchList();
        // eslint-disable-next-line
    },[])
    const ResearchList = async () => 
    {
        try 
        {          
            const { startDate, endDate } = setDateRange(0, 0, 1, 0, 0);
            const callApi = global.config.API_URL + `research/list/5/none/${startDate}/${endDate}/0`;
            if(global.config.IsPrint) console.info('ResearchList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if( result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sr_id + "/srFile")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sr_id + "/srFileHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].srFile = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                        result[i].srFileHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                    });
                    setProjects(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('ResearchList File :', error);
                    setLoading(false);
                });
            }
            else
            {
                setProjects([]);
                setLoading(false);
            }
            if( global.config.IsPrint === true ) { console.info('ResearchList : Result',result); }
        }
        catch (error) 
        {
            console.error('ResearchList : Error', error.message);
            setLoading(false);
        }
    };
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1500">
                {appLanguage === 'hi' ? 'चल रही प्रायोजित अनुसंधान परियोजनाएँ' : 'ONGOING SPONSORED RESEARCH PROJECTS'}
            </Card.Header>
            <Card.Body>  
            {isLoading ? (
                <Row className='g-3 justify-content-center'>
                {[...Array(2)].map((index) => (
                    <Col md={6} key={index}>
                        <Card className='text-center' data-aos="flip-up" data-aos-duration="1000">
                            <Placeholder className="w-100 card-img-top" style={{minHeight:"150px"}} />
                            <Card.Body>
                                <Card.Title><Placeholder xs={10} bg="dark" /></Card.Title>
                                <Card.Text><Placeholder xs={10} bg="secondary" /></Card.Text>
                                <Button className="btn btn-info w-50"><Placeholder xs={10} bg="white" /></Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                </Row>
            ) : (
                <Row className='g-3 justify-content-center'>
                {Projects.map(sr=>(
                    <Col md={6} key={sr.sr_id}>
                        <Card className='text-center' data-aos="flip-up" data-aos-duration="1000">
                            <Card.Img variant="top" src={global.config.uploadPath+'1240703042.png'} />
                            <Card.Body>
                                <Card.Title>{appLanguage === 'hi' ? (sr.sr_display_en === "1" ? sr.sr_name_hi || '' : sr.sr_name_hi || sr.sr_name) : sr.sr_name}</Card.Title>
                                <Card.Text>{appLanguage === 'hi' ? 'संशोधित किया गया' : 'Updated on'} {formatDate(sr.sr_date)}</Card.Text>
                                {appLanguage === 'hi' ? 
                                    (
                                        sr.sr_display_en === "1" && sr.srFileHi 
                                        ? <a href={sr.srFileHi} className='btn btn-info'>{t('Download')}</a> 
                                        : sr.srFileHi 
                                            ? <a href={sr.srFileHi} className='btn btn-info'>{t('Download')}</a> 
                                            : sr.srFile
                                            ? <a href={sr.srFile} className='btn btn-info'>{t('Download')}</a> 
                                            : ''
                                    ) : (
                                        sr.srFile 
                                        ? <a href={sr.srFile} className='btn btn-info'>{t('Download')}</a> 
                                        : ''
                                    )
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                </Row>
            )}
            </Card.Body>
        </Card>
    );    
}
export default ResearchProjects;